import { createContext } from "react"

import { ProductObj } from "scrivito/Objs/Product/ProductObjClass"

export interface AttributeInformationContextType {
  productObj: ProductObj | null
}

const defaultAttributeInformationContext: AttributeInformationContextType = {
  productObj: null
}

export const AttributeInformationContext = createContext<
  AttributeInformationContextType | null | undefined
>(defaultAttributeInformationContext)
